// Authors: Delaney Gillilan
// Icon: mdi-light:vector-intersection
// Slug: Runs an expression when an element intersects with the viewport
// Description: An attribute that runs an expression when an element intersects with the viewport.

import type { AttributePlugin } from '../../../engine/types'
import { modifyTiming } from '../../../utils/timing'
import { modifyViewTransition } from '../../../utils/view-transitions'
const once = new WeakSet<HTMLOrSVGElement>()

export const OnIntersect: AttributePlugin = {
  type: 'attribute',
  name: 'onIntersect',
  keyReq: 'denied',
  onLoad: ({ el, mods, rx }) => {
    let callback = () => rx()
    callback = modifyTiming(callback, mods)
    callback = modifyViewTransition(callback, mods)
    const options = { threshold: 0 }
    if (mods.has('full')) {
      options.threshold = 1
    } else if (mods.has('half')) {
      options.threshold = 0.5
    }
    let observer: IntersectionObserver | null = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            callback()
            if (observer && once.has(el)) {
              observer.disconnect()
            }
          }
        }
      },
      options,
    )
    observer.observe(el)
    if (mods.has('once')) {
      once.add(el)
    }
    return () => {
      if (!mods.has('once')) {
        once.delete(el)
      }
      if (observer) {
        observer.disconnect()
        observer = null
      }
    }
  },
}
